import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {DocumentCheckIcon} from '@/app/icons';

import {KycDocumentUploader} from './components';
import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';
import './styles';

const IdvDocsContent = () => {
  const {t} = useTranslation();
  const {onSubmitForm} = useViewModelProvider();

  return (
    <Box className="idv-docs-container">
      <Box className="text-container">
        <Typography className="title">{t('kyc.idv_docs.title')}</Typography>
        <Box className="description-content">
          <div className="description-icon">
            <DocumentCheckIcon />
          </div>
          <Typography className="description-text">
            {t('kyc.idv_docs.description_1')}
            <span className="description-text-bold">
              {t('kyc.idv_docs.description_2')}
            </span>
            {t('kyc.idv_docs.description_3')}
          </Typography>
        </Box>
      </Box>
      <Box className="modak-form-container">
        <KycDocumentUploader
          onSubmit={function (): void {
            onSubmitForm();
          }}
        />
      </Box>
    </Box>
  );
};

const IdvDocsPage = () => (
  <ViewModelProvider>
    <IdvDocsContent />
  </ViewModelProvider>
);

export default IdvDocsPage;
